<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.outJournalType"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Registro pranešimas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Registro pranešimai. Registro pranešimas"
                  v-model="mainData['out_journal_type-search-simple']"
                />
              </v-col>
              <v-col cols="12" md="12" lg="6">
                <el-text-field
                  label="Objekto ID"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Registro pranešimai. Įgaliojimo IK / prokūros IK"
                  v-model="mainData['mandate_code-search-like']"
                  hide-details
                  :maxlength="100"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-date-picker
                  hide-details
                  label="Gavimo data nuo"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Registro pranešimai. Gavimo data nuo"
                  v-model="mainData['sent_at-search-from']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-date-picker
                  hide-details
                  label="Gavimo data iki"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Registro pranešimai. Gavimo data iki"
                  v-model="mainData['sent_at-search-to']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="searchData(true)"
                />
                <el-report-btn @downloadReport="downloadReport" object="out-journals" listURL="my-list" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminRegistryMessagesSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.searchData(true)
    },
  },
}
</script>
